import React, { useState } from "react";
import { Parents } from "../../Models/parents.models";
import { ParentDetails } from "./ParentDetails";
import { Card } from "../card";
import { SectionHeader } from "../Header/SectionHeader";
import { ParentAccountDetails } from "./ParentAccountDetails";
import { Button } from "../Button";
import { useUpdateParent } from "../../hooks/parentsHooks/useParents.hooks";
import { useDispatch } from "react-redux";
import {
  setErrorMessage,
  setSuccessMessage,
} from "../../Redux/Slices/alert.slice";
import { SOMETHING_WENT_WRONG } from "../../Constants/messages";
import { verifyParentsRegistrationFields } from "../../Helper/validation/parentsRegistration.validation.helper";
import { isEmpty } from "../../Helper/string.helper";
interface Props {
  parent: Parents;
}
export const ParentInfo = ({ parent }: Props) => {
  const dispatch = useDispatch();

  const [firstName, setFirstName] = useState(parent?.user?.first_name || "");
  const [middleName, setMiddleName] = useState(parent?.user?.middle_name || "");
  const [lastName, setLastName] = useState(parent?.user?.last_name || "");
  const [mobile, setMobile] = useState(parent?.user.mobile || "");
  const [address, setAddress] = useState(parent?.user?.address || "");
  const [gender, setGender] = useState(parent?.user?.gender || "");
  const [parentalRelationship, setParentalRelationship] = useState<string>(
    parent.parental_relationship || ""
  );

  const [email, setEmail] = useState(parent?.user?.email || "");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const { isLoading: isUpdatingParentDetail, mutate: updateParentDetail } =
    useUpdateParent({
      parentId: parent.id,
    });

  const onUpdateParentDetails = () => {
    const payload: any = {
      firstName,
      middleName,
      lastName,
      mobile,
      address,
      gender,
      parentalRelationship,
      email,
    };
    if (password) {
      payload.password = password;
      payload.confirmPassword = confirmPassword;
    }

    if (
      !verifyParentsRegistrationFields({
        fieldsToVerify: payload,
        dispatch,
        skipPasswordValidation: isEmpty(password),
      })
    )
      return;

    updateParentDetail(payload, {
      onSuccess: () => {
        dispatch(setSuccessMessage("Parents details has been updated."));
      },
      onError: (error: any) => {
        dispatch(
          setErrorMessage(error.response.data.message || SOMETHING_WENT_WRONG)
        );
      },
    });
  };
  return (
    <Card
      cardTitle="Parent information"
      cardSubTitle="Edit, Review, and Save Comprehensive Details for Parent Profiles, Including Contact Information and Other Relevant Data"
    >
      <SectionHeader headerText="General information" />
      <ParentDetails
        firstName={firstName}
        middleName={middleName}
        lastName={lastName}
        mobile={mobile}
        address={address}
        gender={gender}
        parentalRelationship={parentalRelationship}
        onFirstNameChange={(firstName) => {
          setFirstName(firstName);
        }}
        onMiddleNameChange={(middleName) => {
          setMiddleName(middleName);
        }}
        onlastNameChange={(lastName) => {
          setLastName(lastName);
        }}
        onMobileChange={(mobile) => {
          setMobile(mobile);
        }}
        onAddressChange={(address) => {
          setAddress(address);
        }}
        onGenderChange={(gender) => {
          setGender(gender);
        }}
        onParentalRelationShipChange={(parentalRelation) => {
          setParentalRelationship(parentalRelation);
        }}
      />
      <SectionHeader
        headerText="Account information"
        subText="Enter precise account details for parents during updating. This information will serve as their login credentials for secure access to the system."
      />
      <ParentAccountDetails
        email={email}
        password={password}
        confirmPassword={confirmPassword}
        onEmailChange={(email) => setEmail(email)}
        onPasswordChange={(password) => setPassword(password)}
        onConfirmPasswordChange={(confirmPassword) =>
          setConfirmPassword(confirmPassword)
        }
        isUpdating
      />

      <Button
        text="Save"
        onClick={onUpdateParentDetails}
        loading={isUpdatingParentDetail}
      />
    </Card>
  );
};
